// 3rd party imports
import * as React from 'react';

// bernie
import { withLocalization, LocalizedText } from 'bernie-l10n';

// ui
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkFigure, UitkImage } from 'uitk-react-images';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';

// components
import { AffiliateCTA } from '../affiliate-cta';
import { LocalizedComponentProps } from '@shared-ui/localization-context';

export interface IntroProps extends LocalizedComponentProps {
  locale?: string;
}

interface IconProps {
  src: string;
  label: string;
  live?: boolean;
}

@withLocalization
export class Intro extends React.Component<IntroProps> {
  public render() {
    const Icon: React.FC<IconProps> = ({ src, label, live = true }) => (
      <UitkLayoutFlex direction="column" alignItems="center">
        <UitkSpacing margin={{ blockstart: 'three' }}>
          <div className="icon">
            <UitkImage alt={label} src={src} />
          </div>
        </UitkSpacing>
        <UitkText size={300} weight="bold">
          {label}
        </UitkText>
        {!live && <UitkText size={100}>coming soon</UitkText>}
      </UitkLayoutFlex>
    );

    return (
      <>
        <UitkHeading tag="h1" size={2}>
          <LocalizedText message="lp.branding.text1" />
          <UitkText theme="default">
            <LocalizedText message="lp.image.subtext" />
          </UitkText>
        </UitkHeading>
        <UitkLayoutFlex direction="row" space="six" wrap="wrap">
          <UitkLayoutFlexItem>
            <Icon src="../../images/icons/expedia.svg" label="Expedia" />
          </UitkLayoutFlexItem>
          <UitkLayoutFlexItem>
            <Icon src="../../images/icons/vrbo.svg" label="Vrbo"/>
          </UitkLayoutFlexItem>
          <UitkLayoutFlexItem>
            <Icon src="../../images/icons/hcom.svg" label="Hotels.com" live={false} />
          </UitkLayoutFlexItem>
          <UitkLayoutFlexItem>
            <Icon src="../../images/icons/orbitz.svg" label="Orbitz" live={false} />
          </UitkLayoutFlexItem>
          <UitkLayoutFlexItem>
            <Icon src="../../images/icons/travelocity.svg" label="Travelocity" live={false} />
          </UitkLayoutFlexItem>
          <UitkLayoutFlexItem>
            <Icon src="../../images/icons/ebookers.svg" label="Ebookers" live={false} />
          </UitkLayoutFlexItem>
        </UitkLayoutFlex>
        <UitkText spacing="six">
          <UitkText inline={true} weight="bold">
            <LocalizedText message="lp.joinus.text1" />
          </UitkText>{' '}
          <UitkText inline={true}>
            <LocalizedText message="lp.joinus.text2" />
          </UitkText>
        </UitkText>
        <UitkText spacing="six">
          <AffiliateCTA locale={this.props.locale} />
        </UitkText>
        <UitkFigure className="intro-image">
          <UitkImage alt="Expedia Group Affiliate Program" src="../../images/Expedia-EPS.svg" />
        </UitkFigure>
      </>
    );
  }
}
